import React, { useEffect, useState } from 'react';
import config from 'react-global-configuration';
import { useSelector } from 'react-redux';
import { HashLink as Link } from 'react-router-hash-link';
import { addUtmQueryString } from '../../helpers/utm';


const CoreLink = ({ to, title, className, children, onClick, blocked = false, ...props }) => {
  const utmCookiesSet = useSelector((state) => state.getIn(['uiInternal', 'utmCookiesSet'], false));
  const [utmLink, setUtmLink] = useState(to);

  const host = window.location.hostname;

  const formsBaseUrls = config.get('BASE_URL_UTM_URLS');

  const isInternal = ((url) => {
    if (/^internal:/.test(url)) {
      to = to.replace(/^internal:/, '');
      return true;
    }

    return false;
  })(to);

  const isEntity = ((url) => {
    if (/^entity:/.test(url)) {
      to = to.replace(/^entity:/, '');
      return true;
    }

    return false;
  })(to);

  const linkHost = (function (url) {
    if (/^https?:\/\//.test(url)) { // Absolute URL.
      const parser = document.createElement('a');
      parser.to = url;

      return parser.hostname;
    }
    else { // Relative URL.
      return window.location.hostname;
    }
  }(to));

  useEffect(() => {
    // If the url matches the UTM forms base url, add the UTM codes to it, if not set already.
    if (formsBaseUrls && to && utmCookiesSet) {
      const startsWithOne = formsBaseUrls.some(url => to.startsWith(url));

      if (startsWithOne) {
        setUtmLink(addUtmQueryString(to));
      } else {
        setUtmLink(to);
      }
    }
  }, [to, utmCookiesSet]);

  if (!to) {
    if (children) {
      return <a className={className}>{children}</a>;
    }
    return <a className={className}>{title}</a>;
  }

  const onClickFunction = (event) => {
    if (blocked) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (onClick) {
      onClick();
    }
  };


  if ((!isInternal || !isEntity) && host !== linkHost) {
    if (children) {
      return <a {...props} onClick={onClickFunction} target="_blank" rel="noopener noreferrer" className={className} href={utmLink}>{children}</a>;
    } else {
      return <a {...props} onClick={onClickFunction} target="_blank" rel="noopener noreferrer" className={className} href={utmLink}>{title}</a>;
    }
  } else if (children) {
    return <Link {...props} onClick={onClickFunction} className={className} to={utmLink}>{children}</Link>;
  } else {
    return <Link {...props} onClick={onClickFunction} className={className} to={utmLink}>{title}</Link>;

  }
};

export default CoreLink;
